const handleReload = () => {
  window.location.reload();
};

export default handleReload;
